var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.367C9 1.2197 8.94194 1.07239 8.83742 0.96633L8.04774 0.164983C7.94323 0.0589226 7.79806 0 7.6529 0C7.50774 0 7.36258 0.0589226 7.25806 0.164983L3.44903 4.0362L1.74194 2.29798C1.63742 2.19192 1.49226 2.133 1.3471 2.133C1.20194 2.133 1.05677 2.19192 0.952258 2.29798L0.162581 3.09933C0.0580645 3.20539 0 3.35269 0 3.5C0 3.64731 0.0580645 3.79461 0.162581 3.90067L2.26452 6.03367L3.05419 6.83502C3.15871 6.94108 3.30387 7 3.44903 7C3.59419 7 3.73935 6.94108 3.84387 6.83502L4.63355 6.03367L8.83742 1.76768C8.94194 1.66162 9 1.51431 9 1.367Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.23efa70b.svg";
export { ForwardRef as ReactComponent };